import AutocallApiService from '@/shared/api/api'

const APIs = {
  api: new AutocallApiService(),
}

export { APIs }
